import { useMediaQuery } from '@material-ui/core';
import { Box, IconButton, Stack } from '@mui/material';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { msgTypes } from 'constants/msgTypes';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { AuthService } from 'services/auth/AuthService';
import { LocalStorageService } from 'services/auth/LocalStorageService';
import showAlert, { logoutAlert } from 'services/shared/alert';
import { useAuth } from 'util/auth';
import "./SideMenu.scss";


const rootSubmenuKeys = ['sub1', 'sub2', 'sub3', 'sub4'];
type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[] | undefined,
  danger?: boolean,
  type?: 'group',
): MenuItem {
  return { key, icon, children, label, type, danger } as MenuItem;
}

const getUserRole = async () => {
  const userRole = await LocalStorageService.getUserRole();
  return userRole;
}

let items: MenuItem[] = [];

const SideMenu = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [openKeys, setOpenKeys] = useState(['']);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const toggleCollapsed = () => {
    auth.setMenuCollapsed(!auth.getMenuCollapsed());
  };
  const [menuList, setMenuList] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  // Media query for xs screen
  const isXsScreen = useMediaQuery("(max-width: 900px)");

  //set visited route on currenct state
  let location = useLocation();
  const [current, setCurrent] = useState("");


  useEffect(() => {
    if (location) {
      let split = [];
      if ((location.pathname.toString()).includes("/")) {
        split = (location.pathname.toString()).split("/");
        const endPoint = split[split?.length - 1];
        if (current !== endPoint) {
          try {
            const navigateedUrl = endPoint;
            const matched = menuList.filter(data => {
              return data.key === navigateedUrl
            })
            if (matched.length > 0) {
              setCurrent(endPoint);
            } else {
              setCurrent(current)
            }
          } catch (error) {
          }
        } else {
          setCurrent(current);
        }
      }
    }
  }, [location, current]);


  useEffect(() => {
    async function fetchMenu() {
      const res = await AuthService.getMenuList();
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setMenuList(res.data);
        setCurrent(res.data[0]?.key);
        authenticateMenuItems(res.data);
      }
    }
    fetchMenu();
    //  companyDetails();
  }, []);


  const authenticateMenuItems = async (menuItems: any) => {
    const userRole = await getUserRole();
    items = [];

    menuItems.forEach((menu) => {
      if (menu.children.length === 0) {
        if (menu.role.includes(userRole)) {
          items.push(getItem(menu.label, menu.key, <i className={menu.icon} aria-hidden="true"></i>, undefined, menu.danger));
        }
      } else {
        const childmenu: MenuItem[] = [];
        menu.children?.forEach(element => {
          if (element.role.includes(userRole)) {
            const item = getItem(element.label, element.key, <i className="fa fa-circle fa-xs" aria-hidden="true"></i>);
            childmenu.push(item);
          }
        });
        if (childmenu.length > 0) {
          const itemWithChildren = getItem(menu.label, menu.key, <i className={menu.icon} aria-hidden="true"></i>, childmenu);
          items.push(itemWithChildren);
        }
      }
    });
    setMenuItems(items);
  };

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 1140) {
      auth.setMenuCollapsed(true);
    }
  }, [window.innerWidth]);


  useEffect(() => {

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        if (!auth.getMenuCollapsed()) {
          auth.setMenuCollapsed(true);
        }
      }
    };

    if (isXsScreen) {

      document.addEventListener('mousedown', handleClickOutside);
    } else {

      document.removeEventListener('mousedown', handleClickOutside);
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [auth, isXsScreen]);


  const logout = async () => {
    const logoutFlag = await logoutAlert(msgTypes.CONFORMATION_MESSAGE.LOGOUT, msgTypes.CONFORMATION_ICON.ERROR, "logout");
    if (logoutFlag) {
      localStorage.clear();
      auth.logout();
      navigate('/login');
      showAlert(msgTypes.SUCCESS.msg, msgTypes.LOGGED_OUT, msgTypes.success, msgTypes.OK_KEY);
    }
  };

  const onMenuClick = (key) => {
    if (key === 'logout') {
      logout();
    } else {
      navigate(key);
      if (isXsScreen) {
        auth.setMenuCollapsed(true);
      }
    }
  }

  return (
    <>
      <div className={auth.getMenuCollapsed() ? 'side-menu-close' : 'side-menu-open'}>
        <Box
          ref={menuRef}
          className={auth.getMenuCollapsed() ? 'menu menu-scroll-width menu-count-width' : 'menu menu-scroll-width'}
          marginTop={8}
          width={auth.getMenuCollapsed() ? { xs: 0, md: 80 } : 270}
          bgcolor={'black'}
          height={"91.3vh"}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <div>
            <Stack className='logo-header' direction={"column"} alignItems={auth.getMenuCollapsed() ? "center" : "end"}>
              <div className='logo-section'><img src='/images/1wn-logo.png' className='logo-img' /></div>
              <IconButton className='sidemenu-bars d-none' id='my-toggle-btn' onClick={toggleCollapsed} sx={{ color: 'white' }}>
                {!auth.getMenuCollapsed() ? <></> : <i className="fa fa-bars" aria-hidden="true"></i>}
              </IconButton>
            </Stack>

            <div>
              <Menu
                className='text-white menu-content'
                style={{ backgroundColor: "black", width: auth.getMenuCollapsed() ? 80 : 270 }}
                //defaultSelectedKeys={['1']}
                mode="inline"
                theme="dark"
                items={menuItems}
                selectedKeys={[current]}
                onClick={({ key }) => { onMenuClick(key); setCurrent(key); }}
                onOpenChange={onOpenChange}
                openKeys={openKeys}
              />

              <div className='sidenav-footer social-icons'>
                <Stack direction="row" spacing={.5}>
                  <div className='social-icons-images d-flex'>
                    <div className='icons--'>
                      <a href="https://www.instagram.com/1wn.co/" target="_blank">
                        <img src="/images/certificate/instagram.png" className='social-media' alt="instagram-icon" />
                      </a>
                    </div>
                    <div className='icons--'>
                      <a href="https://www.facebook.com/1wn.co" target="_blank">
                        <img src="/images/certificate/facebook.png" className='social-media' alt="facebook-icon" />
                      </a>
                    </div>
                    <div className='icons--'>
                      <a href="https://www.linkedin.com/company/1wn-one-world-one-network/" target="_blank">
                        <img src="/images/certificate/linkedin.png" className='social-media' alt="linkedin-icon" />
                      </a>
                    </div>
                    <div className='icons--'>
                      <a href="https://www.youtube.com/@1wn_co" target="_blank">
                        <img src="/images/certificate/youtube.png" className='social-media' alt="youtube-icon" />
                      </a>
                    </div>
                  </div>
                </Stack>
              </div>
            </div>
          </div>
        </Box>
        <IconButton onClick={toggleCollapsed} className='collapse-button-input' sx={{ color: '#b8b5b5' }}>
          {!auth.getMenuCollapsed() ?
            <>
              <div className='navbar bg-transparent shadow-none'>
                <div className="sidenav-toggler-inner">
                  <i className="sidenav-toggler-line one-collapse"></i>
                  <i className="sidenav-toggler-line"></i>
                  <i className="sidenav-toggler-line two-collapse"></i>
                </div>
              </div>
              <Box className="collapse-btn"> &nbsp;</Box>
            </>
            : <div className='navbar bg-transparent shadow-none'>
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
              </div>
            </div>}
        </IconButton>
      </div>

    </>
  );
};

export default SideMenu;












